import * as React from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';
import Collapse from '../../../../components/collapse/Collapse';
import FlightDetail from '../flightDetail/FlightDetail';
import PaymentDetail from '../paymentDetail/PaymentDetail';
import HeaderPNRTrackerContainer from '../headerPNRTracker/HeaderPNRTrackerContainer';
import CancelResumeDetail from '../cancelResumeDetail/CancelResumeDetail';

const propTypes = {
  showModalSuccess: PropTypes.any,
  refundTaxOnly: PropTypes.any,
  afterCancel: PropTypes.any,
  data: PropTypes.any,
  addPayment: PropTypes.any,
  handleCancel: PropTypes.any,
  handleChangeTrip: PropTypes.any
};

class PNRDetailContainer extends React.Component {
  componentDidMount() {
    if (this.props.afterCancel) {
      this.props.showModalSuccess(this.props.data.pnrNumber, this.props.refundTaxOnly);
    }
  }

  render() {
    return (
      <div className="DetailPNRContainer">
        <div className="body-min-height bg-white">
          <HeaderPNRTrackerContainer
            hideCancelButton={true}
            hideBackButton={false}            
            hideChangeTrip={true}
            pnrItem={this.props.data}
            addPayment={this.props.addPayment}
            handleCancel={this.props.handleCancel}
            handleChangeTrip={this.props.handleChangeTrip}
          />
          <div className="padding-eight-top-24">
            <Collapse
              name="collapseDetail"
              label={i18n.translate('label.detailTrip')}
              collapsed={this.props.afterCancel}>
              <FlightDetail data={this.props.data} />
            </Collapse>
          </div>
          <div className="margin-eight-top-48">
            <Collapse
              collapsed={this.props.afterCancel}
              name="collapsePaymentDetail"
              label={i18n.translate('label.paymentDetail')}>
              <PaymentDetail data={this.props.data} />
            </Collapse>
          </div>
          {this.renderCancelInfo(this.props.data)}
        </div>
      </div>
    );
  }

  renderCancelInfo(data) {
    if (data.cancelInfo) {
      return (
        <div className="margin-eight-top-48">
          <Collapse name="collapseCancelDetail" label={i18n.translate('label.cancelInfo')}>
            <CancelResumeDetail
              cancelInfo={data.cancelInfo}
              passengerCancelInfo={data.passengerCancelInfo}
            />
          </Collapse>
        </div>
      );
    }
  }
}

PNRDetailContainer.propTypes = propTypes;

export default PNRDetailContainer;



// WEBPACK FOOTER //
// ./src/page/flightDetailsPage/components/pnrDetailContainer/PNRDetailContainer.jsx